import React, { useEffect, useState } from "react";
import moment from "moment";
import { PulseLoader } from "react-spinners";

import ContainerDiversionTable from "../common/tables/ContainerDiversionTable";
import { getContainerDiversionData } from "../../services/TransporterDataService";

import "./ContainerDiversion.css";

const ContainerDiversion = () => {
  const [loader, setLoader] = useState(false);
  const [containerDiversionData, setContainerDiversionData] = useState([]);

  const [date, setDate] = useState({
    fromdate: moment().format("YYYY-MM-DD"),
    todate: moment().format("YYYY-MM-DD"),
  });

  const [searchText, setSearchText] = useState("");

  const getContainerDiversion = async () => {
    setLoader(true);

    try {
      const request = {
        fromDate: date.fromdate,
        toDate: date.todate,
      };

      const response = await getContainerDiversionData(request);

      setContainerDiversionData(response?.data || []);
    } catch (error) {
      console.error(
        "Error fetching Container Diversion data:",
        error
      );

      setContainerDiversionData([]);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getContainerDiversion();
  }, [date]);

  const refreshContainerDiversion = async () => {
    await getContainerDiversion();
  };

  const handleFromDateChange = (e) => {
    setDate((prev) => ({
      ...prev,
      fromdate: e.target.value,
    }));
  };

  const handleToDateChange = (e) => {
    setDate((prev) => ({
      ...prev,
      todate: e.target.value,
    }));
  };

  const filteredData = containerDiversionData.filter((item) => {
    if (!searchText) return true;

    const search = searchText.toLowerCase();

    return (
      String(item?.Booking_Number || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Market || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Country || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Container_Number || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Transporter_Container_Number || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Vehicle_No || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Seal_No || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.FLEETX_LR_No || "")
        .toLowerCase()
        .includes(search) ||
      String(item?.Driver_No || "")
        .toLowerCase()
        .includes(search)
    );
  });

  return (
    <>
      {/* Header */}
      <div className="flex-row mb-12 counterHeaderResponsive">
        <h1>Container Diversion</h1>
      </div>

      {/* Search + Date Filter */}
      <div className="container-diversion-filter-row">

        {/* Search */}
        <div className="container-diversion-search">
          <input
            type="text"
            className="form-control"
            placeholder="search here.."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {/* From Date */}
        <div className="container-diversion-date">
          <label>From-</label>

          <input
            type="date"
            className="form-control"
            value={date.fromdate}
            onChange={handleFromDateChange}
          />
        </div>

        {/* To Date */}
        <div className="container-diversion-date">
          <label>To-</label>

          <input
            type="date"
            className="form-control"
            value={date.todate}
            onChange={handleToDateChange}
          />
        </div>

      </div>

      {/* Loader */}
      {loader && (
        <div className="container-diversion-loader">
          <PulseLoader
            color="#007bff"
            size={20}
            margin={10}
          />
        </div>
      )}

      {/* Always show table */}
      {!loader && (
        <ContainerDiversionTable
          tableData={filteredData}
          date={date}
          setDate={setDate}
          refreshContainerDiversion={refreshContainerDiversion}
        />
      )}
    </>
  );
};

export default ContainerDiversion;